export default __webpack_public_path__ + "static/media/forgotPassword.ee2f612d.svg";